import React, {Component} from 'react';
import SubCardPrincipal from './sub_card_principais.js';
import './sub_principais_consultores.css'

export default class SubPrincipaisConsultores extends Component {

    constructor(){
        super();
        this.state = {
            profissionaisTop:[
                {id:'1',nome:'Ana Cláudia',categorias: [{nome: 'Direito Constitucional'}, 
                                            {nome:'Direito Administrativo'}], 
                status: false, img:'ANA.jpg', url:'/usuario/contratar'},
                {id:'2',nome:'Cláudio', status: false, img:'claudio.jpg', url:'#'},
                {id:'3',nome:'Roberto Assunção', status:true,img:'roberto.jpg',url:'#'},
                {id:'4',nome:'Márcia Araújo', status:false,img:'marcia.jpg',url:'#'},
            ]

        }

    }


    render() {
        return(
            <div className = "col-md-12 sub-listagem-principal">
                <p className = "pCustom">Principais consultores</p>
                <div className = "container ">
                    <div className = "row">
                        {
                            this.state.profissionaisTop.map((profissional)=>{
                                return(
                                    <SubCardPrincipal key={profissional.id} profissional={profissional}/>
                                )
                            })
                        }
                    </div>

                </div>
            </div>




        )
    }

}